import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader } from '../ui/Loader';

interface ProtectedRouteProps {
    children: React.ReactNode;
    type: 'admin' | 'school';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, type }) => {
    const { school, loading, isAdmin, isAuthenticated } = useAuth();
    const location = useLocation();

    if (loading) {
        return <Loader fullScreen />;
    }

    if (type === 'admin') {
        if (!isAuthenticated || !isAdmin) {
            return <Navigate to="/login" state={{ from: location }} replace />;
        }
    }

    if (type === 'school') {
        if (!isAuthenticated || !school) {
            return <Navigate to="/login" state={{ from: location }} replace />;
        }
    }

    return <>{children}</>;
};
